import { useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "../../lib/api";
import { Page, Field, btnGold, inputCls } from "../../components/store/ui";

const FAQ = [
  ["Comment sont fixés les prix ?", "Chaque prix est calculé à partir du coût fournisseur réel, de la livraison, des frais de paiement, des taxes et d'une provision retours. Nous n'affichons jamais de faux prix barrés."],
  ["Les délais de livraison sont-ils garantis ?", "Ce sont des estimations fournies par nos partenaires logistiques. Le suivi est disponible dans votre espace client."],
  ["Comment demander un retour ?", "Deux possibilités, dans les 30 jours suivant la réception : depuis le site (Mon compte → ouvrez la commande → « Demander un retour »), ou en nous écrivant à boutique.abri@gmail.com en indiquant votre numéro de commande, le produit et le motif. Nous vous répondons avec les instructions de retour."],
  ["Quand suis-je remboursé ?", "Le remboursement est émis via Stripe sur votre moyen de paiement d'origine. Les cas simples sont traités automatiquement ; les autres sont examinés par notre équipe."],
  ["Mes données bancaires sont-elles stockées ?", "Non. Le paiement est entièrement traité par Stripe."],
];

export default function Help() {
  const [f, setF] = useState({ name: "", email: "", subject: "", message: "" });
  const [sent, setSent] = useState(false);
  const send = async (e) => {
    e.preventDefault();
    try { await api.post("/contact", f); setSent(true); } catch (er) { toast.error(errMsg(er)); }
  };
  return (
    <Page kicker="Centre d'aide" title="Comment pouvons-nous aider ?">
      <div className="grid lg:grid-cols-2 gap-16">
        <div data-testid="help-faq">
          <div className="label-xs mb-4">FAQ</div>
          {FAQ.map(([q, a], i) => <details key={q} data-testid={`faq-item-${i}`} className="border-b border-white/5 py-4"><summary className="cursor-pointer text-sm">{q}</summary><p className="text-sm text-muted-foreground mt-3 leading-relaxed">{a}</p></details>)}
        </div>
        <div>
          <div className="label-xs mb-4">Contact</div>
          {sent ? <p data-testid="contact-success" className="text-[#10B981]">Message reçu. Nous vous répondrons par email.</p> : (
            <form onSubmit={send} className="space-y-4">
              <Field label="Nom" testid="contact-name" required value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} />
              <Field label="Email" testid="contact-email" type="email" required value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} />
              <Field label="Sujet" testid="contact-subject" required value={f.subject} onChange={(e) => setF({ ...f, subject: e.target.value })} />
              <textarea data-testid="contact-message" required minLength={5} rows={5} value={f.message} onChange={(e) => setF({ ...f, message: e.target.value })} className={inputCls} placeholder="Votre message" />
              <button data-testid="contact-submit" className={btnGold}>Envoyer</button>
            </form>
          )}
        </div>
      </div>
    </Page>
  );
}
